import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
    const user = JSON.parse(localStorage.getItem("user"));

    // ❌ Not logged in
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // ❌ Role not allowed
    if (allowedRoles && !allowedRoles.includes(user.role)) {
        return <Navigate to="/login" replace />;
    }

    // ✅ Allowed
    return children;
};

export default ProtectedRoute;
